import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Logo } from "./Logo";

export const ProcessingScreen = ({ steps, done = false, title = "Analisi AI in corso", subtitle, progressLabel, realProgress = null }) => {
  const [progress, setProgress] = useState(0);
  const [stepIdx, setStepIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => {
      setProgress((p) => {
        if (done) return Math.min(100, p + 5);
        const ceiling = 99;
        const floor = realProgress != null ? Math.min(ceiling, realProgress) : 0;
        if (p >= ceiling) return ceiling;
        // fast at first, then keep creeping up in ever-smaller steps
        // (never stalls: always adds at least a small amount, slower near the top)
        const minInc = p < 90 ? 0.5 : p < 96 ? 0.14 : p < 98 ? 0.06 : 0.025;
        const inc = Math.max(minInc, (ceiling - p) * 0.02);
        // la barra non scende mai sotto l'avanzamento REALE dei documenti
        return Math.min(ceiling, Math.max(p + inc, floor));
      });
    }, 140);
    return () => clearInterval(t);
  }, [done, realProgress]);

  useEffect(() => {
    setStepIdx(Math.min(steps.length - 1, Math.floor((progress / 100) * steps.length)));
  }, [progress, steps.length]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 relative overflow-hidden">
      <div className="grid-lines absolute inset-0 opacity-40" />
      <div className="relative z-10 w-full max-w-lg">
        <div className="flex justify-center mb-10"><Logo /></div>

        {/* Scanning orb */}
        <div className="relative mx-auto mb-10 h-40 w-40 flex items-center justify-center">
          <div className="absolute h-24 w-24 rounded-full border border-gold-500/40 pulse-ring" />
          <div className="absolute h-24 w-24 rounded-full border border-gold-500/40 pulse-ring" style={{ animationDelay: "1s" }} />
          <div className="relative h-24 w-24 rounded-2xl card-dark overflow-hidden glow-gold flex items-center justify-center">
            <div className="absolute inset-x-0 top-0 h-8 bg-gradient-to-b from-gold-400/40 to-transparent scan-line" />
            <motion.div className="font-heading font-black text-3xl text-gold-400"
              key={Math.round(progress)}>
              {Math.round(progress)}%
            </motion.div>
          </div>
        </div>

        <h2 className="font-heading font-bold text-2xl text-white text-center mb-2">{title}</h2>
        {subtitle && <p className="text-slate-400 text-sm text-center mb-4">{subtitle}</p>}

        {progressLabel && (
          <div data-testid="bill-progress" className="mx-auto mb-6 w-fit rounded-full border border-gold-500/30 bg-gold-500/10 px-4 py-1.5 text-sm text-gold-300 font-medium">
            {progressLabel}
          </div>
        )}

        <div className="h-1.5 w-full rounded-full bg-white/5 overflow-hidden mb-8">
          <motion.div className="h-full rounded-full bg-gradient-to-r from-gold-500 to-gold-300"
            style={{ width: `${progress}%` }} transition={{ ease: "linear" }} />
        </div>

        <div className="space-y-2.5">
          {steps.map((s, i) => (
            <div key={i} className="flex items-center gap-3 text-sm">
              <div className={`h-1.5 w-1.5 rounded-full transition-colors ${i < stepIdx ? "bg-gold-400" : i === stepIdx ? "bg-gold-400 animate-pulse" : "bg-white/15"}`} />
              <span className={i <= stepIdx ? "text-slate-200" : "text-slate-600"}>{s}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
